
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import OperationContent from './page2/OperationContent'

export default {
name: "Stores",
components: {Tab, TabItem, OperationContent},
created() {


},
methods: {
onSwipeLeft() {
this.selectedIndex = (this.selectedIndex + 3) % 4
},
onSwipeRight() {
this.selectedIndex = (this.selectedIndex + 1) % 4
},
handler(i) {
this.selectedIndex = i
if (this.selectedIndex == 0) {
this.operate = 'store'
} else if (this.selectedIndex == 1) {
this.operate = 'center'
} else if (this.selectedIndex == 2) {
this.operate = 'dev'
} else if (this.selectedIndex == 3) {
this.operate = 'roam'
}
}
},
data() {
return {
selectedIndex: 0,
operate: 'store'
}
}
}



// WEBPACK FOOTER //
// ./src/components/Fix.vue